import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { App } from "./App";
import { AppErrorBoundary } from "./AppErrorBoundary";
import { PrivateFileSession } from "./workspace/PrivateFileSession";
import "@xlacking/design-tokens/theme.css";
import "./index.css";

if (typeof window.xlackingDesktop === "object") document.documentElement.classList.add("desktop-shell");
if ("serviceWorker" in navigator) {
  const controlledAtBoot = navigator.serviceWorker.controller !== null;
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!controlledAtBoot || refreshing) return;
    refreshing = true;
    window.location.reload();
  });
  void navigator.serviceWorker.register("/sw.js");
}

const root = document.getElementById("root");
if (root === null) throw new Error("Missing application root");
const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;

if (convexUrl === undefined || convexUrl.length === 0) {
  root.innerHTML = '<div class="config-missing"><h1>Not configured</h1><p>This build has no backend URL. Set <code>VITE_CONVEX_URL</code> and rebuild.</p></div>';
} else {
  const client = new ConvexReactClient(convexUrl);
  createRoot(root).render(
    <StrictMode>
      <ConvexAuthProvider client={client}>
        <PrivateFileSession><AppErrorBoundary>
          <App />
        </AppErrorBoundary></PrivateFileSession>
      </ConvexAuthProvider>
    </StrictMode>
  );
}
